
// Inspiration: vuetify server-side v-data-table with search:
// https://codepen.io/pbastowski/pen/LmvGMz

import CustomerProjectsQuery from "../../graphql/customerproject/customerprojects.graphql"
import CountCustomerProjectsQuery from "../../graphql/customerproject/countcustomerprojects.graphql"
import SearchCustomerProjectsQuery from "../../graphql/customerproject/searchcustomerprojects.graphql"

import Dialog from "../../base_classes/Dialog"

import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import modaldialog from "./modaldialog"
@Component({
    apollo: {
        customerProjects: {
            query: CustomerProjectsQuery,
            variables() {
                return {
                    offset: 0,
                    limit: 10,
                    customerUuid: this.customer && this.customer.uuid,
                }
            },
            skip() {
                return !this.show || !this.countCustomerProjects
            },
            result() {
                if (this.customerProjects && this.customerProjects.length == 0) {
                    this.$emit("hide")
                }
            },
            fetchPolicy: "no-cache",
        },
        countCustomerProjects: {
            query: CountCustomerProjectsQuery,
            variables() {
                return { customerUuid: this.customer && this.customer.uuid }
            },
        },
        searchCustomerProjects: {
            query: SearchCustomerProjectsQuery,
            debounce: 300,
            variables() {
                return {
                    query: this.search && this.search.length >= this.minSearchCharacters ? this.search : undefined,
                    customerUuid: this.customer && this.customer.uuid,
                }
            },
            skip() {
                return !this.search || this.search.length < this.minSearchCharacters
            },
            update(data) {
                this.searchLoading = false
                return data.searchCustomerProjects
            },
            fetchPolicy: "no-cache",
        },
    },
})
export default class SelectCustomerProjectDialog extends Dialog {
    // "Constants"

    minSearchCharacters = 2
    listHeight = "300px"    

    headers = [
        {
            text: "Customer",
            value: "customerName",
            sortable: false,
        },
        {
            text: "Name",
            value: "name",
            sortable: false,
        },
        {
            text: "Project no",
            value: "projectNo",
            align: "right",
            sortable: false,
        },
    ]

    customerProjects: any = []

    get fullscreen() {
        return this.$vuetify.breakpoint.xsOnly
    }

    mounted(){
        this.resize()
    }

    resize(){
        var height =  window.innerHeight - 180
        this.listHeight = height + "px"
    }

    // Force autofocus every time dialog is shown
    @Watch("show")
    onShow() {
        if (this.show)
            this.$nextTick(() => {
                this.restrictShrinking()
                ;(this.$refs.search as HTMLInputElement).focus()
            })
    }

    @Prop({ default: false })
    required!: boolean

    @Prop()
    readonly customer?: any

    @Watch("customer")
    onCustomer() {
        if (this.customer && this.customer.uuid) {
            this.$apollo.queries.customerProjects.setVariables({
                customerUuid: this.customer.uuid,
            })
            this.$apollo.queries.customerProjects.refresh()
            this.$apollo.queries.countCustomerProjects.refresh()
            this.$apollo.queries.searchCustomerProjects.refresh()
        }
    }

    page: number = 1
    itemsPerPage: number = 10

    @Watch("page")
    @Watch("itemsPerPage")
    onPaginationUpdate() {
        this.$apollo.queries.customerProjects.setVariables({
            offset: (this.page - 1) * this.itemsPerPage,
            limit: this.itemsPerPage,
        })
        this.$apollo.queries.customerProjects.refresh()
    }

    get loading() {
        return this.$apollo.queries.customerProjects.loading || this.$apollo.queries.countCustomerProjects.loading
    }

    get projectsWithRecentsFirst() {
        return []
            .concat(this.customerProjects.filter((p: any) => this.isRecent(p)))
            .concat(this.customerProjects.filter((p: any) => !this.isRecent(p)))
    }

    search = ""
    lastSearch = ""
    searchLoading = false
    searchCustomerProjects = []

    enter() {
        if (!this.search || this.searchLoading) return
        if (this.searchCustomerProjects.length == 1) this.select(this.searchCustomerProjects[0])
    }

    changeSearch() {
        // Need "manual" loading flag because of debounced query
        if (this.search == this.lastSearch) return
        this.lastSearch = this.search
        this.searchLoading = this.search ? true : false
        this.searchCustomerProjects = []
    }

    select(item: any) {
        this.$emit("select", item)
        this.show = false
        if (item) this.storeSelection(item)
    }

    updated() {
        this.restrictShrinking()
    }

    restrictShrinking() {
        // Don't allow the dialog to shrink when content shrinks (makes for an annoying user experience while searching)
        if (!this.$refs["card"]) return
        const dialogElement = (this.$refs["card"] as Vue).$el.parentElement
        if (dialogElement) {
            const height = Math.min(dialogElement.clientHeight, window.innerHeight)
            const width = Math.min(dialogElement.clientWidth, window.innerWidth)
            if (height > 0 && width > 0) {
                dialogElement.setAttribute("style", `width: unset; min-width: ${width}px; min-height: ${height}px`)
            }
        }
    }

    clickCreateCustomerProject() {
        this.$emit("createCustomerProject")
    }
}
